import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTITEMIMPORT_LOAD_BY_ID,

    ACTION_PROJECTITEMIMPORT_SAVE,

    IProjectItemImportLoadByIdAction,
    IProjectItemImportLoadFailureAction,
    IProjectItemImportLoadSuccessAction,

    IProjectItemImportSaveAction,
    IProjectItemImportSaveSuccessAction,
    IProjectItemImportSaveFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

} from "../actions/projectItemImport";
import { projectItemImportApi } from "../services/projectItemImport";


export const
    getProjectItemImportByIdEpic = (action$): Observable<IProjectItemImportLoadSuccessAction | IProjectItemImportLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMIMPORT_LOAD_BY_ID)
            .mergeMap((action: IProjectItemImportLoadByIdAction) => {
                return projectItemImportApi
                    .getProjectItemImportById(action.id, action.trialId)
                    .map(response =>
                        LoadSuccess(response.projectItemImport, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectItemImportEpic = (action$): Observable<IProjectItemImportSaveSuccessAction | IProjectItemImportSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMIMPORT_SAVE)
            .mergeMap((action: IProjectItemImportSaveAction) => {
                return projectItemImportApi
                    .setProjectItemImport(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.projectItemImport, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    };

